import { render, staticRenderFns } from "./questionnaire-list.vue?vue&type=template&id=9180effc&lang=pug&"
import script from "./questionnaire-list.vue?vue&type=script&lang=js&"
export * from "./questionnaire-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports